import { css } from '@emotion/react';
import cns from 'classnames';
import { FC, HTMLAttributes } from 'react';

export const TABLE_FOOTER_CLASSNAME = '__mapui_tableFooter';

export type TableFooterProps = HTMLAttributes<HTMLTableSectionElement>;

const applyMainStyles = () => (theme) => {
  const footer = css(theme.table.footer);

  const styles = [footer];

  return css(...styles);
};

export const TableFooter: FC<TableFooterProps> = ({
  children,
  className,
  ...others
}: TableFooterProps) => (
  <tfoot
    css={applyMainStyles()}
    className={cns(TABLE_FOOTER_CLASSNAME, className)}
    {...others}
  >
    {children}
  </tfoot>
);
